import { AppConfig } from '@aipb/env/util';
import { MapLayer } from '../model/map-layer.model';
import { PredefinedExploration } from '../model/predefined-exploration.model';
import { ExplorerEnv } from './explorer.env';

export class ExplorerConfig extends AppConfig<ExplorerEnv> {
  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get initialSearchQuery(): string {
    return this.config.initialSearchQuery || '';
  }

  get predefinedExplorations(): PredefinedExploration[] {
    return this.config.predefinedExplorations || [];
  }

  get entitySearchLimit(): number {
    // @ts-expect-error foo
    return this.config.entitySearchLimit;
  }

  get mapLayers(): Record<string, MapLayer> {
    return this.config.mapLayers || {};
  }
}
